module.exports = ":host ::ng-deep .hrcl-informatic-steps {\n  margin-top: 20px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admission/admission-steps/admission-steps.component.scss
// module id = ./src/app/admission/admission-steps/admission-steps.component.scss
// module chunks = main